/* Main product slider */

const productSwiper = new Swiper(".js-mySwiper", {
  direction: 'horizontal',
  slidesPerView: 5,
  spaceBetween: 10,
  freeMode: true,
  watchSlidesProgress: true,
  mousewheel: true,
  breakpoints: {
    750: {
      direction: 'vertical',
      slidesPerView: 'auto',
    },
    989: {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  },
  on: {
    transitionEnd: function () {
      var slidesCount = this.slides.length;
      var lastSlide = document.querySelectorAll('.thumbnail-list__item')[slidesCount - 1];
      if (lastSlide && lastSlide.classList.contains('swiper-slide-visible')) {
        document.querySelector('.js-mySwiper').classList.add('hide-after');
      } else {
        document.querySelector('.js-mySwiper').classList.remove('hide-after');
      }
    },
    sliderMove: function () {
      console.log('work');
      var slidesCount = this.slides.length;
      var lastSlide = document.querySelectorAll('.thumbnail-list__item')[slidesCount - 1];
      if (lastSlide && lastSlide.classList.contains('swiper-slide-visible')) {
        document.querySelector('.js-mySwiper').classList.add('hide-after');
      } else {
        document.querySelector('.js-mySwiper').classList.remove('hide-after');
      }
    }
  }
});

(function () {
  function calcHeight() {
    if ((window.innerWidth < 1200) && !document.querySelector('.product__media')) return;

    let productMediaHeight = document.querySelector('.mySwiper2__list .swiper-slide-active .product__media').offsetHeight;
    document.querySelector('.js-mySwiper').style.height = productMediaHeight + 'px';
    productSwiper.update();
  }
  window.calcHeight = calcHeight;
  window.addEventListener('resize', calcHeight);
})();


(function () {
  let mediaQuery = window.matchMedia("(orientation: landscape)"),
      productSwiper2;

  function checkOrientation() {
    return mediaQuery.matches ? 2.5 : 1.4;
  }
  
  function initSlider() {
    if (productSwiper2 !== undefined)
     productSwiper2.destroy();

     productSwiper2 = new Swiper(".js-mySwiper2", {
      spaceBetween: 8,
      slidesPerView: checkOrientation(),
      arrows: false,
      thumbs: {
        swiper: productSwiper,
      },
      breakpoints: {
       
        750: {
          arrows: false,
          slidesPerView: 1,
          spaceBetween: 40,
        },
      },
      on: {
        afterInit: function () {
          setTimeout(function () {
            window.calcHeight();
          }, 301);
        }
      },
      navigation: {
        nextEl: ".swiper-product-button-next",
        prevEl: ".swiper-product-button-prev",
      }
    });
  }
  initSlider();
  mediaQuery.addListener(initSlider);
  
}());




/* Dentists that recommend us slider */

const dentistsSlider = new Swiper('.js-dentists__swiper', {
  slidesPerView: 1.2,
  spaceBetween: 15,
  arrows: false,
  navigation: {
    nextEl: '.dentists-button-next',
    prevEl: '.dentists-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    450: {
      slidesPerView: 1.4,
    },
    550: {
      slidesPerView: 1.8,
    },
    650: {
      slidesPerView: 2.1,
    },
    767: {
      slidesPerView: 2.2,
    },
    820: {
      slidesPerView: 2.4,
    },
    920: {
      slidesPerView: 2.8,
    },
    989: {
      slidesPerView: 2.8,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

/* Instagram slider */

const instagramSlider = new Swiper('.js-instagram__swiper', {
  slidesPerView: 1.15,
  spaceBetween: 15,
  arrows: false,
  navigation: {
    nextEl: '.instagram-button-next',
    prevEl: '.instagram-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    450: {
      slidesPerView: 1.4,
    },
    550: {
      slidesPerView: 1.8,
    },
    650: {
      slidesPerView: 2.1,
    },
    767: {
      slidesPerView: 2.2,
    },
    820: {
      slidesPerView: 2.4,
    },
    920: {
      slidesPerView: 2.8,
    },
    989: {
      slidesPerView: 2.8,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});


/* js-contact-tiles slider */

const contactTiles = new Swiper('.js-contact-tiles', {
  slidesPerView: 1.15,
  spaceBetween: 25,
  arrows: false,
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    450: {
      slidesPerView: 1.4,
    },
    550: {
      slidesPerView: 1.8,
    },
    650: {
      slidesPerView: 2.1,
    },
    767: {
      slidesPerView: 2.2,
    },
    820: {
      slidesPerView: 2.4,
    },
    920: {
      slidesPerView: 3,
    },
  },
});

/* Video and Img slider */

const videoImgSlider = new Swiper('.js-video-img-slider-init', {
  slidesPerView: 1.2,
  spaceBetween: 15,
  arrows: false,
  navigation: {
    nextEl: '.video-img-slider-button-next',
    prevEl: '.video-img-slider-button-prev',
  },
  breakpoints: {
    420: {
      slidesPerView: 1.8,
    },
    575: {
      slidesPerView: 2.5,
    },
    989: {
      slidesPerView: 2.5,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

/* Video and Img slider randomize slide */

if (document.querySelectorAll('.js-video-img-slider__wrapper-randomizer').length) {

  const box = document.getElementById('js-video-img-slider-box');

  if (box.children.length > 103) {
    const ul = document.querySelector('.js-video-img-slider__wrapper-randomizer');
    
    for (let i = ul.children.length; i >= 0; i--) {
      ul.appendChild(ul.children[Math.random() * i | 0]);
    }
  }
}

/* Random Video slider */

const randomVideoSlider = new Swiper('.js-random-video-slider-init', {
  slidesPerView: 1.2,
  spaceBetween: 15,
  arrows: false,
  navigation: {
    nextEl: '.random-video-slider-button-next',
    prevEl: '.random-video-slider-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    450: {
      slidesPerView: 1.4,
    },
    550: {
      slidesPerView: 1.8,
    },
    650: {
      slidesPerView: 2.1,
    },
    767: {
      slidesPerView: 2.2,
    },
    820: {
      slidesPerView: 2.4,
    },
    989: {
      slidesPerView: 2.5,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 13,
    },
  },
});

/* randomize slide */

if (document.querySelectorAll('.js-random-video-slider__wrapper-randomizer').length) {

  const box = document.getElementById('js-random-video-slider-box');

  if (box.children.length > 1) {
    const ul = document.querySelector('.js-random-video-slider__wrapper-randomizer');
    
    for (let i = ul.children.length; i >= 0; i--) {
      ul.appendChild(ul.children[Math.random() * i | 0]);
    }
  }
}

/* Reviews slider */

const reviewsSlider = new Swiper('.js-reviews__swiper', {
  slidesPerView: 1.2,
  spaceBetween: 15,
  arrows: false,
  navigation: {
    nextEl: '.reviews-button-next',
    prevEl: '.reviews-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    450: {
      slidesPerView: 1.4,
    },
    550: {
      slidesPerView: 1.8,
    },
    650: {
      slidesPerView: 2.1,
    },
    767: {
      slidesPerView: 2.2,
    },
    820: {
      slidesPerView: 2.4,
    },
    920: {
      slidesPerView: 2.8,
    },
    989: {
      slidesPerView: 2.8,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

/* Product Recommendations Slider */
function initialRecommendedSlider() {
  const productRecommendSlider = new Swiper('.js-product-recommendations__swiper', {
    slidesPerView: 1.5,
    spaceBetween: 15,
    arrows: false,
    navigation: {
      nextEl: '.recommend-button-next',
      prevEl: '.recommend-button-prev',
    },
    breakpoints: {
      600: {
        slidesPerView: 2.2,
      },
      787: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    }
  });
}


/* Instagram slider randomize slide */

if (document.querySelectorAll('.instagram__swiper-wrapper').length) {
  const ul = document.querySelector('.instagram__swiper-wrapper');
  for (let i = ul.children.length; i >= 0; i--) {
    ul.appendChild(ul.children[Math.random() * i | 0]);
  }
}

/* Enable slider */

var swiper = Swiper;
var init = false;

function swiperLogo() {
  if (window.innerWidth <= 1200) {
    if (!init) {
      init = true;
      swiper = new Swiper(".js-extra__logo-swiper", {
        slidesPerView: 2.5,
        spaceBetween: 15,
        loop: true,
        breakpoints: {
          767: {
            slidesPerView: 5
          }
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperLogo();
window.addEventListener("resize", swiperLogo);


//timer 

// Функция для обновления отсчета времени на странице
function updateCountdown() {
  // Получаем текущее время и время, через 15 минут
var currentTime = new Date().getTime();
var fifteenMinutesLater = new Date(currentTime + (15 * 60 * 1000)).getTime();

// Получаем сохраненное время начала обратного отсчета из localStorage
var savedStartTime = localStorage.getItem('countdownStartTime');

// Если сохраненное время начала обратного отсчета существует, используем его
if (savedStartTime) {
  fifteenMinutesLater = parseInt(savedStartTime) + (15 * 60 * 1000);
} else {
  // Если сохраненного времени нет, сохраняем текущее время в localStorage
  localStorage.setItem('countdownStartTime', currentTime);
}

// Сохраняем время окончания обратного отсчета в localStorage
localStorage.setItem('countdownEndTime', fifteenMinutesLater);
  // Получаем время окончания обратного отсчета из localStorage
  var countdownEndTime = localStorage.getItem('countdownEndTime');
  
  // Если время не установлено, выходим из функции
  if (!countdownEndTime) {
    return;
  }
  
  // Получаем разницу между текущим временем и временем окончания обратного отсчета
  var diff = countdownEndTime - new Date().getTime();
  
  // Если время истекло, очищаем localStorage
  if (diff <= 0 || document.querySelector('.shoping-bar').classList.contains('stop')) {
    document.querySelector('.shoping-bar').classList.add('hide');
    localStorage.removeItem('countdownStartTime');
    localStorage.removeItem('countdownEndTime');
    return;
  }
  
  // Преобразуем разницу времени в минуты и секунды
  var minutes = Math.floor(diff / 1000 / 60);
  var seconds = Math.floor((diff / 1000) % 60);

  // Добавляем ноль перед числом, если количество секунд меньше 10
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  
  // Обновляем отображение времени на странице
  document.getElementById('countdown').innerHTML = minutes + ':' + seconds;
  
  // Обновляем отсчет каждую секунду
  setTimeout(updateCountdown, 1000);
}

if(document.querySelectorAll('.shoping-bar').length) {
  function startCountdown() {
    // Проверяем наличие времени в localStorage каждую секунду
    let countdownInterval = setInterval(function() {
      let countdownEndTime = localStorage.getItem('countdownEndTime');
      if (countdownEndTime) {
        // Если время есть, вызываем функцию countdown()
        clearInterval(countdownInterval); // Останавливаем setInterval()
        updateCountdown();
        if(document.querySelectorAll('.template-cart .shoping-bar').length) {
          document.querySelector('.template-cart .shoping-bar').classList.remove('hide');
        }
        

        let clickCount = sessionStorage.getItem('clickCount') || 0;
        if (clickCount != 2) {
          console.log(clickCount);
          document.querySelector('.shoping-bar').classList.remove('hide');
        }
      }
    }, 1000);
  }
  
  async function checkCartItemsCount() {
    let response = await fetch(window.Shopify.routes.root + 'cart.js'),
    cartData = await response.json(),
    activateCountdown;
    cartData.items.length > 0 ? activateCountdown = true : activateCountdown = false;
    activateCountdown && startCountdown();
  };
  checkCartItemsCount();
}

if(document.querySelectorAll('.shoping-bar .close').length) {
  document.querySelector('.shoping-bar .close').addEventListener('click', function() {
    document.querySelector('.shoping-bar').classList.add('hide');
  })
}

const myElement = document.querySelector('.shoping-bar .close');

let clickCount = sessionStorage.getItem('clickCount') || 0;

function handleClick() {
  clickCount++;
  if (clickCount === 2) {
    document.querySelector('.shoping-bar').classList.add('hide');
    // document.querySelector('.shoping-bar').classList.add('stop');
    // localStorage.removeItem('countdownStartTime');
    // localStorage.removeItem('countdownEndTime');
  }
  sessionStorage.setItem('clickCount', clickCount);
}

myElement.addEventListener('click', handleClick);



document.addEventListener('DOMContentLoaded', function() {
  var isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  var elements = document.querySelectorAll('[data-glightbox]');

  if(elements.length && isMobile) {
    elements.forEach(function(element) {
      element.addEventListener('click', function() {
        setTimeout(function() {
          var plyrControl = document.querySelector('.gslide.loaded.current .plyr__control.plyr__control--overlaid');
          plyrControl.click();
        }, 1000);
      });
    });
  }
  
});
